<template lang="pug">
el-collapse#bloco-inserir-contrato-originacao-manualmente
    el-collapse-item(name='cadastroManual')
        h2.cadastro-contrato-originacao__subtitulo(slot='title') Dados do contrato de originação

        el-card(:body-style='{ padding: "20px" }', shadow='never')
            el-form.col-12(label-position='top')
                .row
                    el-form-item.col-3(label='Número do contrato')
                        el-input(v-model='numeroContrato', type='number')

                    el-form-item.col-2(label='Cultura')
                        el-select(
                            v-model='cultura',
                            :loading='loading.culturas',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.culturas',
                                :key='id + nome',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-1(label='Safra')
                        el-select(
                            v-model='safra',
                            :loading='loading.safras',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ ano, id } in opcoes.safras',
                                :key='id + ano',
                                :label='ano',
                                :value='id'
                            )

                    el-form-item.col-3(label='Volume contratado (t)')
                        el-input(v-model='volumeContratado', type='number')

                    el-form-item.col-3(label='Volume recebido (t)')
                        el-input(v-model='volumeRecebido', type='number')

                .row
                    el-form-item.col-3(label='Data do contrato')
                        el-date-picker(
                            v-model='dataContrato',
                            type='date',
                            placeholder='Selecione',
                            format='dd/MM/yyyy'
                        )

                    el-form-item.col-3(label='BP Cliente')
                        el-select(
                            v-model='bpCliente',
                            :loading='loading.bpClientes',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.bpClientes',
                                :key='id + nome',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(label='Fornecedor')
                        el-select(
                            v-model='fornecedor',
                            :loading='loading.fornecedores',
                            @change='definirOpcoesCnpj',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.fornecedores',
                                :key='id + nome',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(label='CNPJ Fornecedor')
                        el-select(
                            v-model='cnpjFornecedor',
                            :disabled='!fornecedor',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='cnpj in opcoes.cnpjFornecedores',
                                :key='cnpj',
                                :label='cnpj',
                                :value='cnpj'
                            )

                .row
                    el-form-item.col-3(label='Segmento')
                        el-select(
                            v-model='segmento',
                            :loading='loading.segmentos',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id, codigo } in opcoes.segmentos',
                                :key='id + nome',
                                :label='`${nome} - ${codigo}`',
                                :value='id'
                            )

                    el-form-item.col-3(label='Canal')
                        el-select(
                            v-model='canal',
                            :loading='loading.canais',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.canais',
                                :key='id + nome',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(label='Regional')
                        el-select(
                            v-model='regional',
                            :loading='loading.regionais',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.regionais',
                                :key='id + nome',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-1(label='Estado')
                        el-select(
                            v-model='estado',
                            :loading='loading.estados',
                            @change='buscarMunicipios',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ sigla, id } in opcoes.estados',
                                :key='id + sigla',
                                :label='sigla',
                                :value='id'
                            )

                    el-form-item.col-2(label='Município')
                        el-select(
                            v-model='municipio',
                            :loading='loading.municipios',
                            :disabled='!estado',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.municipios',
                                :key='id + nome',
                                :label='nome',
                                :value='id'
                            )

                .row
                    el-form-item.col-3(label='Gerente regional')
                        el-select(
                            v-model='gerenteRegional',
                            :loading='loading.gerentesRegionais',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.gerentesRegionais',
                                :key='nome + id',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(label='Gerente comercial')
                        el-select(
                            v-model='gerenteComercial',
                            :loading='loading.gerentesComerciais',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.gerentesComerciais',
                                :key='nome + id',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(label='Gestor territorial')
                        el-select(
                            v-model='gestorTerritorial',
                            :loading='loading.gestoresTerritoriais',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.gestoresTerritoriais',
                                :key='nome + id',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3.botao
                        BaseButton(
                            type='primary',
                            :disabled='adicionandoContrato',
                            @click='adicionar'
                        )
                            i.el-icon(
                                :class='adicionandoContrato ? "el-icon-loading" : "el-icon-plus"'
                            )
                            | Adicionar à lista
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import LocalidadeService from '@/services/LocalidadeService';
import { required } from 'vuelidate/lib/validators';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'BlocoInserirContratoOriginacaoManualmente',

    components: {
        BaseButton
    },

    data() {
        return {
            numeroContrato: null,
            cultura: null,
            safra: null,
            volumeContratado: null,
            volumeRecebido: null,
            dataContrato: null,
            bpCliente: null,
            fornecedor: null,
            cnpjFornecedor: null,
            segmento: null,
            canal: null,
            regional: null,
            estado: null,
            municipio: null,
            gerenteComercial: null,
            gerenteRegional: null,
            gestorTerritorial: null,

            opcoes: {
                culturas: [],
                safras: [],
                bpClientes: [],
                fornecedores: [],
                cnpjFornecedores: [],
                segmentos: [],
                canais: [],
                regionais: [],
                estados: [],
                municipios: [],
                gerentesRegionais: [],
                gerentesComerciais: [],
                gestoresTerritoriais: []
            },

            loading: {
                culturas: true,
                safras: true,
                bpClientes: true,
                fornecedores: true,
                cnpjFornecedores: true,
                segmentos: true,
                canais: true,
                regionais: true,
                estados: true,
                municipios: true,
                gerentesRegionais: true,
                gerentesComerciais: true,
                gestoresTerritoriais: true
            },

            tipoPessoa: {
                GERENTE_REGIONAL: 'gerentesRegionais',
                GERENTE_COMERCIAL: 'gerentesComerciais',
                GERENTE_TERRITORIAL: 'gestoresTerritoriais'
            },

            adicionandoContrato: false
        };
    },

    validations: {
        numeroContrato: { required },
        cultura: { required },
        safra: { required },
        volumeContratado: { required },
        volumeRecebido: { required },
        dataContrato: { required },
        bpCliente: { required },
        fornecedor: { required },
        cnpjFornecedor: { required },
        segmento: { required },
        canal: { required },
        regional: { required },
        estado: { required },
        municipio: { required },
        gerenteComercial: { required },
        gerenteRegional: { required },
        gestorTerritorial: { required },

        dados: [
            'numeroContrato',
            'cultura',
            'safra',
            'volumeContratado',
            'volumeRecebido',
            'dataContrato',
            'bpCliente',
            'fornecedor',
            'cnpjFornecedor',
            'segmento',
            'canal',
            'regional',
            'estado',
            'municipio',
            'gerenteComercial',
            'gerenteRegional',
            'gestorTerritorial'
        ]
    },

    mounted() {
        this.buscarCulturas();
        this.buscarSafras();
        this.buscarBpClientes();
        this.buscarFornecedores();
        this.buscarSegmentos();
        this.buscarCanais();
        this.buscarRegionais();
        this.buscarEstados();
        this.buscarPessoas('GERENTE_REGIONAL');
        this.buscarPessoas('GERENTE_COMERCIAL');
        this.buscarPessoas('GERENTE_TERRITORIAL');
    },

    methods: {
        async buscarCulturas() {
            try {
                this.loading.culturas = true;
                const { data } =
                    await ContratoOriginacaoService.buscarCulturas();

                this.opcoes.culturas = data;
                this.loading.culturas = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar as culturas');
            }
        },

        async buscarSafras() {
            try {
                this.loading.safras = true;
                const { data } = await ContratoOriginacaoService.buscarSafras();

                this.opcoes.safras = data;
                this.loading.safras = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar as safras');
            }
        },

        async buscarBpClientes() {
            try {
                this.loading.bpClientes = true;
                const { data } =
                    await ContratoOriginacaoService.buscarBpClientes();

                this.opcoes.bpClientes = data;
                this.loading.bpClientes = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar BP Clientes');
            }
        },

        async buscarFornecedores() {
            try {
                this.loading.fornecedores = true;
                const { data } =
                    await ContratoOriginacaoService.buscarFornecedores();

                this.opcoes.fornecedores = data;
                this.loading.fornecedores = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os fornecedores');
            }
        },

        async buscarSegmentos() {
            try {
                this.loading.segmentos = true;
                const { data } =
                    await ContratoOriginacaoService.buscarSegmentos();

                this.opcoes.segmentos = data;
                this.loading.segmentos = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os segmentos.');
            }
        },

        async buscarCanais() {
            try {
                this.loading.canais = true;
                const { data } = await ContratoOriginacaoService.buscarCanais();

                this.opcoes.canais = data;
                this.loading.canais = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os canais.');
            }
        },

        async buscarRegionais() {
            try {
                this.loading.regionais = true;
                const { data } =
                    await ContratoOriginacaoService.buscarRegionais();

                this.opcoes.regionais = data;
                this.loading.regionais = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar as regionais.');
            }
        },

        async buscarEstados() {
            try {
                this.loading.estados = true;
                const { data } = await LocalidadeService.findNivel1(1);

                this.opcoes.estados = data;
                this.loading.estados = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os estados.');
            }
        },

        async buscarMunicipios() {
            if (!this.estado) return;

            try {
                this.loading.municipios = true;
                const { data } = await LocalidadeService.findNivel2(
                    this.estado,
                    false
                );

                this.opcoes.municipios = data;
                this.loading.municipios = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os municipios.');
            }
        },

        async buscarPessoas(codigoTipoPessoa) {
            try {
                const tipoPessoa = this.tipoPessoa[codigoTipoPessoa];

                this.loading[tipoPessoa] = true;

                const { data } = await ContratoOriginacaoService.buscarPessoa(
                    codigoTipoPessoa
                );
                this.opcoes[tipoPessoa] = data;

                this.loading[tipoPessoa] = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os gerentes.');
            }
        },

        async definirOpcoesCnpj() {
            try {
                if (this.fornecedor) {
                    const { data } = await ContratoOriginacaoService.buscarCpfCnpjFornecedor(this.fornecedor);
                    this.opcoes.cnpjFornecedores = data;
                } else {
                    this.opcoes.cnpjFornecedores = [];
                }
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os CPF/CNPJ do fornecedor.');
            }
        },

        adicionar() {
            if (!this.$v.dados.$invalid) {
                this.adicionandoContrato = true;

                ContratoOriginacaoService.cadastrarManualmente({
                    numeroContrato: this.numeroContrato,
                    idMaterial: this.cultura,
                    idSafra: this.safra,
                    volumeContratado: parseFloat(this.volumeContratado),
                    volumeRecebido: parseFloat(this.volumeRecebido),
                    valorDataContrato: this.dataContrato.getTime(),
                    idBpCliente: this.bpCliente,
                    idSubEmpresa: this.fornecedor,
                    subEmpresaCnpj: this.cnpjFornecedor,
                    idSegmento: this.segmento,
                    idCanal: this.canal,
                    idRegional: this.regional,
                    idMunicipio: this.municipio,
                    idGerenteComercial: this.gerenteComercial,
                    idGestorTerritorial: this.gestorTerritorial,
                    idGerenteRegional: this.gerenteRegional
                })
                    .then(() => {
                        this.$notify.success(
                            `Contrato ${this.numeroContrato} inserido`
                        );

                        this.$emit('contrato-inserido');
                        this.limpar();
                    })
                    .catch(erro => {
                        this.$notify.error({
                            message: erro.response.data.message
                        });
                    })
                    .finally(() => (this.adicionandoContrato = false));
            } else {
                this.$notify.warning(
                    'Todos os campos precisam estar preenchidos.'
                );
            }
        },

        limpar() {
            this.numeroContrato = null;
            this.cultura = null;
            this.safra = null;
            this.volumeContratado = null;
            this.volumeRecebido = null;
            this.dataContrato = null;
            this.bpCliente = null;
            this.fornecedor = null;
            this.cnpjFornecedor = null;
            this.segmento = null;
            this.canal = null;
            this.regional = null;
            this.estado = null;
            this.municipio = null;
            this.gerenteComercial = null;
            this.gerenteRegional = null;
            this.gestorTerritorial = null;
        }
    }
};
</script>

<style lang="scss">
#bloco-inserir-contrato-originacao-manualmente {
    h2.cadastro-contrato-originacao__subtitulo {
        font-size: 16px;
        font-weight: bold;

        margin-bottom: 0px;
        margin-left: 20px;
    }

    .el-card {
        border: none;
    }

    .el-collapse-item {
        border-radius: 10px;
        overflow: hidden;
    }

    .el-collapse-item__content {
        padding: 0px;
    }

    .el-form-item {
        padding: 0 4px;
    }

    .el-select,
    .el-input,
    .el-date-picker,
    .botao {
        width: 100%;
    }

    .row {
        align-items: flex-end;
    }
}
</style>
